import { createBrowserRouter, Navigate } from "react-router-dom";
import { EditorShell } from "./editor/EditorShell";
import { Account } from "./pages/Account";
import { Assets } from "./pages/Assets";
import { McpApi } from "./pages/McpApi";
import { Placeholder } from "./pages/Placeholder";
import { Studio } from "./pages/Studio";
import { AppShell } from "./shell/AppShell";
import { StudioShell } from "./studio/StudioShell";

// Routen — Tools sind NICHT hart verdrahtet: das Studio löst Kategorie/Tool aus der URL
// gegen die Registry auf (§4). Generate ist die Default-Fläche.
export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to="/generate" replace /> },
      { path: "generate", element: <Studio /> },
      { path: "generate/:category", element: <Studio /> },
      { path: "generate/:category/:toolId", element: <Studio /> },
      { path: "assets", element: <Assets /> },
      { path: "account", element: <Account /> },
      // §8/D160 — MCP & API: API-Key-Verwaltung + MCP-/Plugin-Installationsanleitung.
      { path: "mcp", element: <McpApi /> },
      {
        path: "explore",
        element: <Placeholder icon="explore" title="Explore" note="Galerie öffentlicher Generationen — folgt (§13)." />,
      },
      // §11/D66 Editor-Surface (eigene innere Shell, 5-Regionen-Layout). Editor-Typ aus der
      // Registry (kein hartes Ref). /canvas (§13 „frei kombinierbare Arbeitsfläche") → /editor.
      { path: "editor", element: <EditorShell /> },
      { path: "editor/:editorType", element: <EditorShell /> },
      { path: "canvas", element: <Navigate to="/editor" replace /> },
      // §9.17/D139 Asset-Studio (Vollbild im Content-Bereich). Deep-Link: /studio?asset=&kind=&fps=.
      { path: "studio", element: <StudioShell /> },
      { path: "*", element: <Navigate to="/generate" replace /> },
    ],
  },
]);
